/*---------------------------------------------------------*\
 * Imports
\*---------------------------------------------------------*/
import PubSub from 'pubsub-js';
import keyboard from 'keycode-ui';

const deps = {};
/*---------------------------------------------------------*\
 * NavbarController
\*---------------------------------------------------------*/
class NavbarController {
  //-----------------------------------
  // Constructor
  //-----------------------------------
  constructor($scope, $element, navigationService, topics) {
    this.name = 'navbar';
    deps.topics = topics;
    deps.$element = $element;
    deps.$scope = $scope;
    deps.navigationService = navigationService;

    if (this.flex) {
      deps.$element.addClass('flex');
    }

    const token1 = PubSub.subscribe(deps.topics.headerMain.resetSubnav, () => {
      this.select(0);
    });

    deps.$scope.$on('$destroy', () => {
      PubSub.unsubscribe(token1);
    });
  }

  //-----------------------------------
  // Methods
  //-----------------------------------
  getCurrentItem() {
    return this.items[this.selectedIndex];
  }

  select(index) {
    const topics = deps.topics.nav;
    this.selectedIndex = index;
    this.onSelect({
      item: this.items[index],
      index
    });
    PubSub.publish(topics.enter, { source: this.name, data: this.getCurrentItem() });
  }

  //-----------------------------------
  // Events
  //-----------------------------------
  onKeyDown(e, item) {
    const topics = deps.topics.nav;
    const buttonElements = [].slice.call(deps.$element.children());
    // parentElement is <news12-button>
    let buttonIndex = buttonElements.indexOf(e.target.parentElement);
    switch (true) {
      case keyboard.isUp(e):
        PubSub.publish(topics.up, 'navbar');
        break;
      case keyboard.isDown(e):
        PubSub.publish(topics.down, { source: 'navbar', item });
        break;
      case keyboard.isLeft(e):
        if (!this.cycleNavigation && buttonIndex === 0) {
          return;
        }
        buttonIndex = buttonIndex === 0 ? buttonElements.length - 1 : buttonIndex - 1;
        deps.navigationService.focusEl('navbar', buttonIndex);
        e.preventDefault();
        break;
      case keyboard.isRight(e):
        if (!this.cycleNavigation && buttonIndex === buttonElements.length - 1) {
          return;
        }
        buttonIndex = (buttonIndex + 1) % buttonElements.length;
        deps.navigationService.focusEl('navbar', buttonIndex);
        e.preventDefault();
        break;
    }
  }
}

NavbarController.$inject = ['$scope', '$element', 'navigationService', 'topics'];

export default NavbarController;



/** WEBPACK FOOTER **
 ** ./client/app/components/common/navbar/navbar.controller.js
 **/